export const initialState = {
  servicesType: "",
  servicesPosition: "",
  servicePlan: "",

  carpet: "",
  dishwashing: "",
  furniture: "",
  insideFridge: "",
  insideOven: "",
  window: "",
  numberOfRooms: "",

  firstName: "",
  tel: "",

  tashkentDistricts: "",
  address: "",
};

export const tashkentDistricts = [
  { id: 0, value: "", option: "Quote.select", disabled: true, selected: true },
  { id: 1, value: "Bektemir", option: "Quote.district.items.bektemir" },
  { id: 2, value: "Chilonzor", option: "Quote.district.items.chilonzor" },
  { id: 3, value: "Yashnobod", option: "Quote.district.items.yashnobod" },
  { id: 4, value: "Mirobod", option: "Quote.district.items.mirobod" },
  {
    id: 5,
    value: "Mirzo Ulug'bek",
    option: "Quote.district.items.mirzoUlugbek",
  },
  { id: 6, value: "Olmazor", option: "Quote.district.items.olmazor" },
  { id: 7, value: "Sergeli", option: "Quote.district.items.sergeli" },
  { id: 8, value: "Shayxontohur", option: "Quote.district.items.shayxontohur" },
  { id: 9, value: "Uchtepa", option: "Quote.district.items.uchtepa" },
  { id: 10, value: "Yakkasaroy", option: "Quote.district.items.yakkasaroy" },
  { id: 11, value: "Yangihayot", option: "Quote.district.items.yangihayot" },
];

export const additionalServices = [
  {
    id: 1,
    key: "carpet",
    value: "Carpet dry cleaning 1 hr",
    forLanguage: "Quote.AdditionalServices.carpet",
  },
  {
    id: 2,
    key: "dishwashing",
    value: "Dishwashing 1 hour",
    forLanguage: "Quote.AdditionalServices.dishwashing",
  },
  {
    id: 3,
    key: "furniture",
    value: "Dry cleaning of upholstered furniture 1",
    forLanguage: "Quote.AdditionalServices.furniture",
  },
  {
    id: 4,
    key: "insideFridge",
    value: "Inside fridge",
    forLanguage: "Quote.AdditionalServices.insideFridge",
  },
  {
    id: 5,
    key: "insideOven",
    value: "Inside oven",
    forLanguage: "Quote.AdditionalServices.insideOven",
  },
  {
    id: 6,
    key: "window",
    value: "Clean interior windows",
    forLanguage: "Quote.AdditionalServices.interiorWindows",
  },
];

export const servicesPosition = {
  cleaning: [
    {
      id: 0,
      value: "",
      option: "Quote.select",
      disabled: true,
      selected: true,
    },
    {
      id: 1,
      value: "General Cleaning",
      option: "Quote.ServicesPosition.residential.generial",
    },
    {
      id: 2,
      value: "Deep Cleaning",
      option: "Quote.ServicesPosition.residential.deep",
    },
    {
      id: 3,
      value: "Move in and Move out Cleaning",
      option: "Quote.ServicesPosition.residential.movie",
    },
    {
      id: 4,
      value: "Post Construction Cleaning",
      option: "Quote.ServicesPosition.residential.postConstruction",
    },
  ],
  // commercial: [
  //   {
  //     id: 1,
  //     value: "General Cleaning",
  //     option: "Quote.ServicesPosition.commercial.generial",
  //   },
  //   {
  //     id: 2,
  //     value: "Deep Cleaning",
  //     option: "Quote.ServicesPosition.commercial.deep",
  //   },
  //   {
  //     id: 3,
  //     value: "Move in and Move out Cleaning",
  //     option: "Quote.ServicesPosition.commercial.movie",
  //   },
  // ],
  moving: [
    {
      id: 0,
      value: "",
      option: "Quote.select",
      disabled: true,
      selected: true,
    },
    {
      id: 1,
      value: "Residential Moving",
      option: "Quote.ServicesPosition.postConstruction.residential",
    },
    {
      id: 2,
      value: "Commercial Moving",
      option: "Quote.ServicesPosition.postConstruction.commercial",
    },
  ],
  // [
  //   {
  //     id: 1,
  //     value: "Residential",
  //     lang: "Quote.ServicesPosition.moving.residential",
  //   },
  //   {
  //     id: 2,
  //     root: "Commercial",
  //     lang: "Quote.ServicesPosition.moving.commercial",
  //   },
  // ]
};

export const servicePlan = [
  {
    id: 1,
    value: "",
    option: "Quote.select",
    disabled: true,
    selected: true,
  },
  {
    id: 2,
    value: "2 x times in a week",
    option: "Quote.ServicesPlan.week2",
  },
  {
    id: 3,
    value: "1 x time in a week",
    option: "Quote.ServicesPlan.week1",
  },
  {
    id: 4,
    value: "2 x times in a month",
    option: "Quote.ServicesPlan.month2",
  },
  {
    id: 5,
    value: "1 x time in a month",
    option: "Quote.ServicesPlan.month1",
  },
  {
    id: 6,
    value: "On time cleaning service",
    option: "Quote.ServicesPlan.cleaningOne",
  },
];
